import { ChainId, ChainName } from '../types/chain';
import { isStaEnv } from './env';

export const SUPPORTED_CHAIN_IDS_TESTNET = [ChainId.MONAD_TESTNET];

export const SUPPORTED_CHAIN_IDS_MAINNET = [ChainId.MONAD_MAINNET];

export const SUPPORTED_CHAIN_IDS = isStaEnv
  ? SUPPORTED_CHAIN_IDS_TESTNET
  : SUPPORTED_CHAIN_IDS_MAINNET;

export const DEFAULT_CHAIN_ID = isStaEnv
  ? ChainId.MONAD_TESTNET
  : ChainId.MONAD_MAINNET;

const chainIdToChainName: Record<ChainId, ChainName> = {
  [ChainId.MONAD_MAINNET]: ChainName.MONAD,
  [ChainId.MONAD_TESTNET]: ChainName.MONAD_TESTNET,
};

export const getChainName = (chainId: ChainId): ChainName => {
  return chainIdToChainName[chainId];
};

export const getIsSupportedChainId = (chainId?: number): chainId is ChainId =>
  !!chainId && SUPPORTED_CHAIN_IDS.includes(chainId as ChainId);

const explorers: Record<ChainId, string> = {
  [ChainId.MONAD_MAINNET]: 'https://monadvision.com',
  [ChainId.MONAD_TESTNET]: 'https://testnet.monadvision.com',
};

export const chainInfos = {
  [ChainId.MONAD_MAINNET]: {
    isTestnet: false,
    chainId: ChainId.MONAD_MAINNET,
    label: 'Monad Mainnet',
    explorer: explorers[ChainId.MONAD_MAINNET],
    rpcUrls: ['https://rpc-mainnet.monadinfra.com/rpc/JhF1CULmMuaLURAymWkjlxiwvukyIlT4'],
    // rpcUrls: ['https://monad-mainnet.g.alchemy.com/v2/Y5ga5OYofEok4bqUdbj82'],
    wsUrls: ["wss://rpc-mainnet.monadinfra.com/rpc/JhF1CULmMuaLURAymWkjlxiwvukyIlT4"],
    nativeCurrency: 'MON',
    icon: '/images/monad-chain.svg',
  },
  [ChainId.MONAD_TESTNET]: {
    isTestnet: true,
    chainId: ChainId.MONAD_TESTNET,
    label: 'Monad testnet',
    explorer: explorers[ChainId.MONAD_TESTNET],
    rpcUrls: ['https://testnet-rpc.monad.xyz'],
    wsUrls: ['wss://monad-testnet.g.alchemy.com/v2/IyI-OISQ-bRNF0i7gyVew'],

    nativeCurrency: 'MON',
    icon: '/images/monad-chain.svg',
  },
} satisfies Record<
  ChainId,
  {
    chainId: ChainId;
    label: string;
    rpcUrls: string[];
    wsUrls: string[];
    /**
     * use for matching wallet config, does not need to be same as project token type definition
     * */
    nativeCurrency: string;
    isTestnet: boolean;
    explorer: string;
    icon: string;
  }
>;

export const getIsTestnet = (chainId: ChainId) => {
  return chainInfos[chainId].isTestnet;
};

export const getChainInfo = (chainId: ChainId) => {
  return chainInfos[chainId];
};
